// API Configuration and Base Functions (uses env: REACT_APP_API_URL)
import { API_BASE_URL } from '../config';

export { API_BASE_URL };

// Generic API call function (credentials: 'include' so session cookies work in production)
export const apiCall = async (endpoint, options = {}) => {
  const url = `${API_BASE_URL}${endpoint}`;
  const config = {
    credentials: 'include',
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
    ...options,
  };

  try {
    const response = await fetch(url, config);
    
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    
    return await response.json();
  } catch (error) {
    console.error('API call failed:', error);
    throw error;
  }
};

// GET request helper
export const get = (endpoint, options = {}) => {
  return apiCall(endpoint, { method: 'GET', ...options });
};

// POST request helper
export const post = (endpoint, data, options = {}) => {
  return apiCall(endpoint, {
    method: 'POST',
    body: JSON.stringify(data),
    ...options,
  });
};

// PUT request helper
export const put = (endpoint, data, options = {}) => {
  return apiCall(endpoint, {
    method: 'PUT',
    body: JSON.stringify(data),
    ...options,
  });
};

// DELETE request helper
export const del = (endpoint, options = {}) => {
  return apiCall(endpoint, { method: 'DELETE', ...options });
};

// Axios-like API client for compatibility
export const apiClient = {
  get: async (endpoint, config = {}) => {
    const response = await apiCall(endpoint, { method: 'GET', ...config });
    return { data: response };
  },
  post: async (endpoint, data, config = {}) => {
    const response = await apiCall(endpoint, { method: 'POST', body: JSON.stringify(data), ...config });
    return { data: response };
  },
  patch: async (endpoint, data, config = {}) => {
    const response = await apiCall(endpoint, { method: 'PATCH', body: JSON.stringify(data), ...config });
    return { data: response };
  },
  delete: async (endpoint, config = {}) => {
    const response = await apiCall(endpoint, { method: 'DELETE', ...config });
    return { data: response };
  }
};

